import { Icon } from "@phosphor-icons/react";
import { useEffect, useState } from "react";

interface Props {
  Icon: Icon;
  color?: string;
  clicked: boolean;
  className?: string;
}

const ReactiveIcon: React.FC<Props> = ({ Icon, color, clicked, className }) => {
  const [weight, setWeight] = useState<"regular" | "bold" | "duotone" | "fill">(
    "regular",
  );

  const handleMouseEnter = () => {
    if (!clicked) {
      setWeight("duotone");
    }
  };

  const handleMouseLeave = () => {
    if (!clicked) {
      setWeight("regular");
    }
  };

  useEffect(() => {
    if (clicked) {
      setWeight("fill");
    } else {
      setWeight("regular");
    }
  }, [clicked]);

  return (
    <Icon
      color={color}
      size={25}
      weight={weight}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`cursor-pointer ${className}`}
    />
  );
};

export default ReactiveIcon;
